import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4d4683a7")

_pushScopeId("data-v-4d4683a7")
const _hoisted_1 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_RadioInput = _resolveComponent("RadioInput")!
  const _component_SelectList = _resolveComponent("SelectList")!
  const _component_List = _resolveComponent("List")!
  const _component_DateRange = _resolveComponent("DateRange")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createBlock("form", {
    onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.submitHRAdminReportRequest(_ctx.reportData.reportType)), ["prevent"])),
    "aria-label": _ctx.reportData.formAriaLabel
  }, [
    (_ctx.reportData.showAdditionalControls)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode(_component_RadioInput, {
            radioInputValue: _ctx.radioInputValue,
            primaryLabel: _ctx.reportData.radioInputPrimaryLabel,
            secondaryLabel: _ctx.reportData.radioInputSecondaryLabel,
            options: _ctx.reportData.radioInputOptions,
            onRadioInputChanged: _ctx.radioInputChanged
          }, null, 8, ["radioInputValue", "primaryLabel", "secondaryLabel", "options", "onRadioInputChanged"]),
          (_ctx.radioInputValue === 'type')
            ? (_openBlock(), _createBlock(_component_SelectList, {
                key: 0,
                header: _ctx.reportData.selectListHeader,
                description: _ctx.reportData.selectListDescription,
                selectData: _ctx.userEmployeeTypes,
                onSelectListChanged: _ctx.selectListChanged
              }, null, 8, ["header", "description", "selectData", "onSelectListChanged"]))
            : _createCommentVNode("", true),
          (_ctx.radioInputValue === 'selected')
            ? (_openBlock(), _createBlock(_component_List, {
                key: 1,
                list: _ctx.uinList,
                header: _ctx.reportData.uinListHeader,
                description: _ctx.reportData.uinListDescription,
                maxListLength: _ctx.reportData.uinListMaxLength,
                onListChanged: _ctx.uinListChanged,
                listType: "number",
                listTypeName: "UIN"
              }, null, 8, ["list", "header", "description", "maxListLength", "onListChanged"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.reportData.showDateControls)
      ? (_openBlock(), _createBlock(_component_DateRange, {
          key: 1,
          startDate: _ctx.startDate,
          endDate: _ctx.endDate,
          startDateRequired: _ctx.reportData.startDateRequired,
          endDateRequired: _ctx.reportData.endDateRequired,
          onStartDateChanged: _ctx.startDateChanged,
          onEndDateChanged: _ctx.endDateChanged
        }, null, 8, ["startDate", "endDate", "startDateRequired", "endDateRequired", "onStartDateChanged", "onEndDateChanged"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Button, {
      text: _ctx.reportData.buttonText,
      type: _ctx.reportData.buttonType,
      ariaLabel: _ctx.reportData.buttonAriaLabel
    }, null, 8, ["text", "type", "ariaLabel"])
  ], 40, ["aria-label"]))
})